<template>
  <v-container id="companies-section">
    <v-layout class="mt-8" column>
      <v-flex>
        <h3 class="display-45-20 primary--text mt-2 mb-2">{{ logosTitle }}</h3>
      </v-flex>
    </v-layout>
    <v-layout align-start justify-space-between wrap fill-height>
      <v-flex
        v-for="(i, key) in generalDFP"
        :key="key"
        text-center
        class="company-item"
        d-flex
        mb-4
        mt-4
        sm4
        md2
      >
        <client-only>
          <GptAd
            flex-grow
            :ad-unit="`3177829/${i.adunit}`"
            :id="i.id"
            :size="[120, 38]"
          />
        </client-only>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    catCode: {
      type: Number,
      required: false,
      default: 30,
    },
    logosTitle: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      generalDFP: {
        1: {
          adunit: 'Logo1newsite',
          id: '1585493459494-011',
        },
        2: {
          adunit: 'Logo2newsite',
          id: '1585493765398-011',
        },
        3: {
          adunit: 'Logo3newsite',
          id: '1585493850505-0111',
        },
        4: {
          adunit: 'Logo4newsite',
          id: '1585494035449-0111',
        },
        5: {
          adunit: 'Logo5newsite',
          id: '1585494121594-0111',
        },
        6: {
          adunit: 'Logo6newsite',
          id: '1585494224909-0111',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
#companies-section .company-item {
  max-width: 180px;
  border-radius: 50%;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f6f7f9;
  width: 100%;
  flex-grow: 0;
  border: 1px solid #dedfe0;
}

.company-img {
  max-width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 1100px) {
  #companies-section .company-item {
    max-width: 140px;
    height: 140px;
  }
}

@media screen and (max-width: 900px) {
  #companies-section .company-item {
    max-width: 120px;
    height: 120px;
  }

  #companies-section .company-item > div {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 800px) {
  #companies-section .company-item {
    max-width: 100px;
    height: 100px;
  }
  #companies-section .company-item > div {
    transform: scale(0.7);
  }
}

@media screen and (max-width: 650px) {
  #companies-section .company-item {
    max-width: 155px;
    height: 155px;
  }

  #companies-section .company-item > div {
    transform: scale(1);
  }
}

@media screen and (max-width: 515px) {
  #companies-section .company-item {
    max-width: 132px;
    height: 132px;
  }

  #companies-section .company-item > div {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 445px) {
  #companies-section .company-item {
    max-width: 100px;
    height: 100px;
  }

  #companies-section .company-item > div {
    transform: scale(0.7);
  }
}
</style>
